import * as sourceStackTrace from 'sourcemapped-stacktrace';

import Singleton from '../Singleton';
import CoreAppService from '../_shared/api/coreAppService';
// eslint-disable-next-line import/extensions
import { ErrorRequest } from '../global';
import WafSubstitutionList from '../_shared/constants/error';
import MixpanelService from './MixpanelService';
import mixpanelConfig from '../_shared/constants/mixpanelConfig';
import { localStorageService } from './StorageService';

// Sanitizes string to remove AWS WAF Blacklist pattern
const sanitizeWord = (word: string) => {
  return WafSubstitutionList.reduce((prev, current) => {
    return prev.replaceAll(current.name, current.sub);
  }, word);
};

export class ErrorService extends Singleton<ErrorService> {
  static async buildBaseProperties() {
    const event = {} as ErrorRequest;

    // user agent
    event.userAgent = window.navigator.userAgent;

    // user window size
    event.windowHeight = window.innerHeight?.toString();
    event.windowWidth = window.innerWidth?.toString();

    // user screen size
    event.screenHeight = window.screen.height?.toString();
    event.screenWidth = window.screen.width?.toString();

    // url of page
    event.pageUrl = sanitizeWord(window.location.href);

    // heap size
    event.jsHeapSizeTotal = window.performance?.memory?.totalJSHeapSize?.toString();
    event.jsHeapSizeUsed = window.performance?.memory?.usedJSHeapSize?.toString();

    // network information NOTE this is only supported on chrome, edge and opera at this moment
    // chrome also limits of the downlink at 10MBit to stop browser fingerprinting
    // any value >= 10MBit is not accurate
    event.downLink = window.navigator?.connection?.downlink?.toString();
    event.networkType = window.navigator?.connection?.effectiveType?.toString();
    event.clientApp = 'WEB5';

    // get userId if authenticated
    const user = localStorageService.getItem('auth')?.user;

    if (user) {
      event.userId = user.id?.toString();
      event.dealerId = user.dealerId?.toString();

      const isCSU = !!(user?.superUserId && user?.superUserId !== user?.id);
      event.isCSU = isCSU.toString();
    }

    return event;
  }

  static async trackError(error: Error) {
    try {
      sourceStackTrace.mapStackTrace(error.stack, async stackTrace => {
        const errorObj = await this.buildBaseProperties();
        const trimmedStackTrace = stackTrace.join('\n');
        errorObj.stackTrace = sanitizeWord(trimmedStackTrace);
        errorObj.errorType = error.name;
        errorObj.errorMessage = error.message;

        const client = await CoreAppService();
        client.instrumentation.sendError(errorObj);
        const mixpanel = MixpanelService.get();
        mixpanel.track(mixpanelConfig.names.appError);
      });
    } catch (ex) {
      /// catch error and return here to prevent potential infinite loop if api is down
    }
  }
}

export default ErrorService;
